import * as Sentry from "@sentry/browser";
import { isThirdPartyFetchFailure } from "./sentry-filters.js";

// Sentry
//
// Config is emitted by _layouts/_partials/sentry.twig, which Craft renders in
// <head> immediately before this bundle. Without it we have no way of knowing
// which environment we're in, so we default to NOT reporting — better to lose a
// stray event than to report local DDEV errors as production, which is what used
// to happen when no environment was set at all (#229).
var sentryConfig = window.__SENTRY_CONFIG__ || null;
var sentryEnvironment = (sentryConfig && sentryConfig.environment) || "unknown";

Sentry.init({
  dsn: "https://9ab6b9f4a55e86e18226b2177d6a8c86@o4507691972558848.ingest.de.sentry.io/4507956614725712",
  environment: sentryEnvironment,
  // Only report from an environment we've positively identified as not-dev.
  enabled: sentryConfig !== null && sentryEnvironment !== "dev",
  initialScope: {
    user: (sentryConfig && sentryConfig.user) || {},
  },
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Noise filtering, mirroring `exceptPatterns` on the PHP target in config/app.php.
  //
  // Without this, anything thrown by a browser extension, an in-app webview or an
  // email-security crawler on a page of ours is reported as ours — six of the
  // thirteen unresolved JS issues in 30 days were exactly that. See #291.
  //
  // Kept narrow on purpose, in the spirit of #230: drop the known-benign case, not
  // the class of error. An `allowUrls` allow-list would be more general, but it
  // silently discards anything whose frame URL we failed to anticipate — a worse
  // failure mode than letting one new extension through.
  ignoreErrors: [
    // Outlook SafeLinks crawler artefact. A promise rejection with no stack, so
    // denyUrls can't see it — Sentry reports URL-less events rather than guessing.
    /Object Not Found Matching Id:\d+/,

    // Android in-app browsers (`sendDataToNative(iabjs://…)` and friends) tearing
    // down the JS bridge while the page is still running.
    /Java object is gone/,
    /Java exception was raised/,

    // Chrome extensions messaging a tab that has already gone.
    /runtime\.sendMessage/,

    // Injected third-party script, not ours: `grep -rn "document.body" src/` finds
    // one hit, an addEventListener in account.js — neither `scrollHeight` nor
    // `appendChild`. If our own code ever touches those, drop these two patterns,
    // because then the error would be a real bug of ours.
    /document\.body\.scrollHeight/,
    /document\.body\.appendChild/,
  ],

  // The general catch for the next extension: anything whose top frame isn't loaded
  // over http(s) from a page didn't come from our bundles.
  denyUrls: [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-(web-)?extension:\/\//,
    /^chrome:\/\//,
    /^webkit-masked-url:/,
    // Android WebView bridges, e.g. iabjs://navigation_performance_logger_android
    /^iabjs:\/\//,
  ],

  // The one case neither of the above can express: a GTM-evaluated tag whose frames
  // carry the page URL, so denyUrls sees a perfectly ordinary https address (#543).
  beforeSend(event) {
    return isThirdPartyFetchFailure(event) ? null : event;
  },
});

// Page behaviour. Each module is a no-op unless the markup it drives is on the
// page, so this one bundle serves every layout (public, account, widget, kiosk).
import "./analytics-beacons.js";
import "./annual-report.js";
import "./cookie-consent.js";
import "./feedback.js";
import "./filter-drawer.js";
import "./filters.js";
import "./map.js";
import "./submit-once.js";
import "./widget-resize.js";

// JS hide utilitys
if(document.querySelector('.js-hide')) {
    document.querySelector('.js-hide').style.display = "none";
}

if(document.querySelector('.js-show')) {
    document.querySelector('.js-show').style.display = "block";
}
